import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "image-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "image-placeholder"
}
const _hoisted_4 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageBlock',
  props: {
    block: {},
    pageIndex: {},
    blockIndex: {}
  },
  emits: ["update", "contentEdit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function updateCaption(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update", { caption: target.value });
  emit("contentEdit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-block",
    style: _normalizeStyle(__props.block.style)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.block.data.src)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.block.data.src,
            alt: __props.block.data.alt,
            class: "image-preview"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, " 🖼️ Clique para adicionar imagem "))
    ]),
    (__props.block.data.src)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          value: __props.block.data.caption,
          onInput: updateCaption,
          placeholder: "Legenda da imagem...",
          class: "image-caption"
        }, null, 40, _hoisted_4))
      : _createCommentVNode("", true)
  ], 4))
}
}

})